import { withStyles, Slider, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const SliderStyled = withStyles((theme: Theme) => ({
  [theme.breakpoints.down(960)]: {
    track: {
      width: 26,
    },
    rail: {
      width: (props: any) => (props.keepDesktopLayout ? '100%' : 23),
    },
    thumb: {
      height: 23,
      width: 35,
    },
  },
  root: {
    color: '#52af77',
    height: 0,
    padding: '0px !important',
    marginBottom: '15px',
  },
  mark: {
    display: 'none',
  },
  thumb: {
    height: 25,
    width: 12.8,
    borderRadius: 4,
    background: COLORS.PRIMARY,
    border: '1px solid #fff',
    marginTop: -6,

    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  track: {
    height: 16,
    borderRadius: 8,
  },
  rail: {
    background: '#394657 !important',
    height: 13,
    borderRadius: 8,
  },
}))(Slider);
